// return space to don't show anything in the row for additional data group
export const EmptyCell = () => <> </>
